import { useCurrentUser } from 'hooks/useCurrentUser';
import { useMutation } from '@apollo/client';
import { LINK_AUTHENTICATOR } from 'modules/Apollo/queries';
import type {
  LinkAuthenticatorMutation,
  LinkAuthenticatorMutationVariables,
} from 'generated/graphql';
import type { ApolloError, FetchResult } from '@apollo/client';
import { WithApolloContext } from 'modules/Apollo/types';

type useLinkAuthenticatorType = {
  linkAuthenticator: (
    totp: string,
    password: string
  ) => Promise<FetchResult<LinkAuthenticatorMutation>>;
  data: Nullable<LinkAuthenticatorMutation>;
  loading: boolean;
  error: Nullable<ApolloError>;
};

const useLinkAuthenticator = ({ context }: WithApolloContext): useLinkAuthenticatorType => {
  const { data: user, refetch } = useCurrentUser({ context });
  const [linkAuthenticatorMutation, { data, loading, error }] = useMutation<
    LinkAuthenticatorMutation,
    LinkAuthenticatorMutationVariables
  >(LINK_AUTHENTICATOR, { context });

  const linkAuthenticator = async (totp: string, password: string) => {
    return linkAuthenticatorMutation({
      variables: {
        userId: user?.me?.id,
        password,
        totp,
      },
      onCompleted(): undefined {
        refetch();
      },
    });
  };

  return { linkAuthenticator, data, loading, error };
};

export default useLinkAuthenticator;
